module.exports = __webpack_public_path__ + "img/frame-advice-l.2789e270.png";